// STEP 1 - Include Dependencies
// Include react
import React from "react";
import ReactDOM from "react-dom";

// Include the react-fusioncharts component
import ReactFC from "react-fusioncharts";

// Include the fusioncharts library
import FusionCharts from "fusioncharts";

// Include the chart type
import Column2D from "fusioncharts/fusioncharts.charts";

// Include the theme as fusion
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";

// Adding the chart and theme as dependency to the core fusioncharts
ReactFC.fcRoot(FusionCharts, Column2D, FusionTheme);

// STEP 2 - Chart Data
function DoughnutChartDistributor(props) {
  let colors = [
    "#89C4F4",
    "#BBBBBB",
    "#337FC9",
    "#9AECF3",
    "#717171",
    "#36DAE9",
    "#333333",
    "#4492A8",
    "#66BCFF",
    "#7094C6",
    "#8ED8B7",
  ];
  let rows = [];

  let chartData = [];
  if (props.hasOwnProperty("cat2Data")) {
    props.cat2Data &&
      Object.keys(props.cat2Data).map((key, index) => {
        rows.push({
          key: key,
          label: props.cat2Data[key].schemeName,
          value: props.cat2Data[key].aum / 10000000,
          color: colors[index],
        });
      });
    chartData = rows;
  } else if (props.hasOwnProperty("cat3Data")) {
    props.cat3Data &&
      Object.keys(props.cat3Data).map((key, index) => {
        rows.push({
          key: key,
          label: props.cat3Data[key].schemeName,
          value: props.cat3Data[key].aum / 10000000,
          color: colors[index],
        });
      });
    chartData = rows;
  }

  console.log("chartData", chartData);

  //console.log("chartData props", props);

  // STEP 3 - Creating the JSON object to store the chart configurations
  const chartConfigs = {
    type: "doughnut2d", // The chart type
    width: "200", // Width of the chart
    height: "200", // Height of the chart
    dataFormat: "json", // Data type

    dataSource: {
      // Chart Configuration
      chart: {
        // caption: "Current Value",
        doughnutRadius: "65%",
        //subcaption: "For all users in 2017",
        showpercentvalues: "1",
        defaultcenterlabel: "₹" + props.total,
        centerLabelFont: "Lato",
        centerLabelFontSize: "12",
        aligncaptionwithcanvas: "0",
        captionpadding: "0",
        numberSuffix: "Cr",
        legendNumColumns: "2",
        decimals: "1",
        showlabels: "0",
        enableSlicing: "0",
        enableRotation: "0",
        showValues: "0",
        plottooltext: "<b>$percentValue</b> <b>$label</b>",
        centerlabel: "Invested Value: $value ",
        theme: "fusion",
        showLegend: "0",
        // legendNumRows: "2",
        legendItemFontSize: "12",
        chartLeftMargin: "0",
        chartTopMargin: "0",
        chartRightMargin: "0",
        chartBottomMargin: "0",
        baseFont: "Lato",
        baseFontSize: "12",
      },
      // Chart Data
      data: chartData,
    },
  };

  return <ReactFC {...chartConfigs} />;
}

export default DoughnutChartDistributor;
